import { useAuth } from '@/composables/useAuth'
import { useErrorReporter } from '@/composables/useErrorReporter'
import { isAccountPortal } from '@/composables/useIsAccountPortal'
import {
	BASE_URL,
	IN_CONVERSION_ROUTES,
	SHARED_COOKIE_DOMAIN
} from '@/constants/index'

const { bugsnagReport } = useErrorReporter()

export default defineNuxtRouteMiddleware(async to => {
	if (import.meta.server) {
		return
	}

	const {
		getAuth, role, isSuperAdmin, showBilling, customerHasNoAccounts, email, fullAddress
	} = useAuth()
	await getAuth()
	// TODO: accountStatus stuff should be getting account at index 0 but kinda waiting on BE to clean up data

	// Bypass middleware for /no-accounts to prevent recursion
	if (to.path === '/no-accounts') {
		// If the user does have accounts, redirect to "/"
		if (!customerHasNoAccounts.value) {
			return navigateTo('/')
		}
		return
	}

	// Redirect to /no-accounts if the user has no accounts, and whitelist the /contact route
	if (isAccountPortal.value && customerHasNoAccounts.value && to.path !== '/contact') {
		bugsnagReport({
			error: new Error(`User has no accounts associated with ${email.value} - ${fullAddress.value}`),
			showToast: false
		})

		return navigateTo('/no-accounts')
	}

	if (!(role.value === 'internal' || (isAccountPortal.value && role.value === 'external'))) {
		bugsnagReport({ error: new Error('Middleware Auth Rejected') })
		const redirectedFrom = useCookie('redirected-from', { domain: SHARED_COOKIE_DOMAIN })
		redirectedFrom.value = to.fullPath

		return navigateTo(`${BASE_URL}/login`, { external: true })
	}

	// if internal employee we do not need to check the cookie to route install status stuff
	if (role.value === 'internal') {
		return
	}

	// reroute to settings home if not super admin when accessing permissions manager
	if (to.path === '/settings/permissions' && !isSuperAdmin.value) {
		return navigateTo('/settings')
	}

	// Restrict non-active users to specific routes
	if (!IN_CONVERSION_ROUTES.includes(to.fullPath) && !showBilling.value) {
		return navigateTo('/install-status')
	}
})
